// extracted by mini-css-extract-plugin
export default {"statusWrapper":"LeadStatus_statusWrapper__EzAe6","statusChipText":"LeadStatus_statusChipText__oGcRc"};